export default function hideVat(selector) {
    $(document).ready(function () {
        setInterval(function(){
            if (document.getElementById(selector)) {
                checkCountry(document.getElementById(selector).title);
            }
        },1000);
    });

    function checkCountry(country) {
        const ueList =
            [
                'Austria',
                'Belgium',
                'Bulgaria',
                'Croatia',
                'Cyprus',
                'Czech Republic',
                'Denmark',
                'Estonia',
                'Finland',
                'France',
                'Germany',
                'Greece',
                'Hungary',
                'Ireland',
                'Italy',
                'Latvia',
                'Lithuania',
                'Luxembourg',
                'Malta',
                'Netherlands',
                'Poland',
                'Portugal',
                'Romania',
                'Slovakia',
                'Slovenia',
                'Spain'
            ];
        if (ueList.includes(country)) {
            $('#vat_form_container').show();
        } else {
            $('#vat_form_container').hide();
        }
    }
}